import { hotjar } from "react-hotjar";
import { app } from "@/config/env";
import { isLocal } from "@/lib/utils";

export function initHotjar() {
  if (isLocal) {
    return;
  }
  if (app.HOTJAR_ID) {
    hotjar.initialize({ id: app.HOTJAR_ID, sv: 6 });
  }
}

export function trackHotjarEvent(event: string) {
  if (isLocal) {
    return;
  }
  hotjar.event(event);
}
